import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["title", "illustration", "children", "buttons", "className"];
import * as React from 'react';
import clsx from 'clsx';
var styles = {
  "root": "Static-root_30sbL",
  "wrapper": "Static-wrapper_1tjiY",
  "illustration": "Static-illustration_193XE",
  "content": "Static-content_1H8ki",
  "title": "Static-title_1TfM-",
  "buttonContainer": "Static-buttonContainer_Qmbck"
};
function Static(_ref) {
  var title = _ref.title,
    illustration = _ref.illustration,
    children = _ref.children,
    buttons = _ref.buttons,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("article", _extends({
      className: clsx(styles.root, className)
    }, extraProps), /*#__PURE__*/React.createElement("div", {
      className: styles.wrapper
    }, illustration ? /*#__PURE__*/React.createElement("div", {
      className: styles.illustration
    }, /*#__PURE__*/React.createElement("img", {
      src: illustration,
      alt: ""
    })) : null, /*#__PURE__*/React.createElement("div", {
      className: styles.content
    }, title ? /*#__PURE__*/React.createElement("h1", {
      className: styles.title
    }, title) : null, children, buttons ? /*#__PURE__*/React.createElement("p", {
      className: styles.buttonContainer
    }, buttons) : null)))
  );
}
export default Static;